import { Add, Delete, Edit, Remove } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import { EditLegalClientDialog } from '../../Clients/EditLegalClientDialog';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { AssignLegalClientsDialog } from '../LegalClient/AssignLegalClientsDialog';
interface IProps {
  title: string;
  subtitle?: string;
  limit?: number;
  members: ILegalClient[];
  setMembers: (newMembers: ILegalClient[]) => void;
  takenLegalClients: ILegalClient[];
  setTakenLegalClients: React.Dispatch<React.SetStateAction<ILegalClient[]>>;
}

export const PurchaseContractMembers: React.FC<IProps> = ({
  title,
  subtitle,
  limit,
  members,
  setMembers,
  takenLegalClients,
  setTakenLegalClients,
}) => {
  const [isMountAssignClients, setIsMountAssignClients] = useState(false);
  const [editedLegalClientId, setEditedLegalClientId] = useState<number>();

  const isReachedLimit = useMemo(
    () => !!(limit && members.length === limit),
    [limit, members.length]
  );

  const takenIds = useMemo(
    () => takenLegalClients.map(x => x.idLegalClient),
    [takenLegalClients, setTakenLegalClients]
  );

  return (
    <>
      <Box sx={{ mt: 5 }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant='h5'>{title}</Typography>
          {subtitle && <Typography>{subtitle}</Typography>}
        </Box>
        <Button
          disabled={isReachedLimit}
          sx={{ float: 'right' }}
          variant='contained'
          onClick={() => setIsMountAssignClients(true)}
        >
          Hinzufügen
        </Button>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nr.</TableCell>
            <TableCell>Vorname</TableCell>
            <TableCell>Nachname</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {members.map((m, i) => (
            <TableRow key={i}>
              <TableCell>{i + 1}</TableCell>
              <TableCell>{m.FirstName}</TableCell>
              <TableCell>{m.LastName}</TableCell>
              <TableCell>
                {takenIds.includes(m.idLegalClient) ? (
                  <IconButton
                    title='Mandanten als Vorgangsbeteiligten entfernen'
                    onClick={() =>
                      setTakenLegalClients(x => [
                        ...x.filter(x => x.idLegalClient !== m.idLegalClient),
                      ])
                    }
                  >
                    <Remove />
                  </IconButton>
                ) : (
                  <IconButton
                    title='Mandanten als Vorgangsbeteiligten hinzufügen'
                    onClick={() => setTakenLegalClients(x => [...x, m])}
                  >
                    <Add />
                  </IconButton>
                )}

                <IconButton
                  title='Mandanten bearbeiten'
                  onClick={() => setEditedLegalClientId(m.idLegalClient)}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  title='Mandanten entfernen'
                  onClick={() =>
                    setMembers(
                      members.filter(y => y.idLegalClient !== m.idLegalClient)
                    )
                  }
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isMountAssignClients && (
        <AssignLegalClientsDialog
          limit={limit}
          assignedLegalClients={members}
          setAssignedLegalClients={setMembers}
          unmount={() => setIsMountAssignClients(false)}
        />
      )}
      {editedLegalClientId && (
        <EditLegalClientDialog
          saveMethod='saveAndClose'
          editedLegalClientId={editedLegalClientId}
          unmount={editedLegalClient => {
            setEditedLegalClientId(undefined);
            if (editedLegalClient) {
              setMembers(
                members.map(x =>
                  x.idLegalClient === editedLegalClient.idLegalClient
                    ? editedLegalClient
                    : x
                )
              );

              setTakenLegalClients(x => [
                ...x.map(x =>
                  x.idLegalClient === editedLegalClient.idLegalClient
                    ? editedLegalClient
                    : x
                ),
              ]);
            }
          }}
        />
      )}
    </>
  );
};
